export default __webpack_public_path__ + "static/media/add-language-icon.2cabd629.svg";